export default {
    getLogsMaestro: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'maestro'
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMaestro/api.js